interface AuthNavLinksProps {
  view: 'sign_in' | 'sign_up' | 'update_password';
}

export const AuthNavLinks = ({ view }: AuthNavLinksProps) => {
  if (view === 'update_password') return null;
  
  return (
    <p className="mt-6 text-center text-sm text-gray-600">
      {view === 'sign_in' ? (
        <>
          Don't have an account?{' '}
          <a href="/auth/signup" className="font-medium text-everest-teal hover:text-everest-teal/90">
            Sign up
          </a>
        </>
      ) : (
        <>
          Already have an account?{' '}
          <a href="/auth/signin" className="font-medium text-everest-teal hover:text-everest-teal/90">
            Sign in
          </a>
        </>
      )}
    </p>
  );
};